import { initVariables } from './variables';
import { setupStyleManager } from './styleManager';

const defaultOptions = {
    enableColors: true,
    enableSizes: true,
    variables: [],
};

export const initCssVariables = (editor, opts = {}) => {
    const options = { ...defaultOptions, ...opts };

    initVariables(editor, options);
    setupStyleManager(editor, options);
};

export { buildVarRef, getVariables, getTargetStyleValue, setTargetStyleValue } from './variables';
export { applyBackendVariables } from './backendAdapter';
